import { getCollectionQueryOptions } from '#pplx/frontend/apps/ask/queries/collection-queries/getCollection.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';
export const useCollectionQuery = ({ collectionSlug, reason, enabled = !!collectionSlug, }) => {
    const { data: result, isLoading } = useQuery({
        ...getCollectionQueryOptions({ collectionSlug, reason }),
        enabled: enabled,
        placeholderData: keepPreviousData,
    });
    return useMemo(() => ({
        collection: result?.collection ?? undefined,
        isLoading,
        errorCode: result?.errorCode,
    }), [result, isLoading]);
};
//# sourceMappingURL=useCollectionQuery.js.map